<template>
  <div class="bg-modal" style="width: 40vw;">
    <text-item :txt="groupTerm" class="pad-m w-maxC" styles="font-l main-h"/>
    <template v-if="appUserStore.currentAppUserData !==  null">
      <inputBox class="mtop-04">
        <inputAreaAuto2 :lines=20 v-model="resultSuggestions[key]" @blur="updatePreferenceText()"/>
      </inputBox>
    </template>
  </div>
</template>



<script setup>
import { computed } from 'vue'
import appuserapi from "@/api/appuserapi"
import { useAppUserStore } from '@/stores/appUser'
const appUserStore = useAppUserStore()

const props = defineProps({
  resultKey: {
    type: String,
    required: true,
  },
  groupTerm: {
    type: String,
    required: true,
  },
})

const key = props.resultKey.charAt(0).toLowerCase() + props.resultKey.slice(1)
let oldText = appUserStore.currentAppUserData.preferences.resultSuggestions[key]

async function updatePreferenceText() {
  if (!appUserStore.currentAppUserData) return
  const newText = resultSuggestions.value[key]
  if (oldText === newText) return
  oldText = newText
  const rsKey = "Rs" + props.resultKey
  appUserStore.updateCachedResultSuggestions()
  await appuserapi.updateReferenceText(rsKey, newText)
}

const resultSuggestions = computed(() => {
  return appUserStore.currentAppUserData.preferences.resultSuggestions
})

</script>

<style scoped>
</style>